
import { Component, Vue } from 'nuxt-property-decorator'
import { usePreferencesStore } from '@/stores/preferences'
import { NeoCheckbox, NeoField, NeoSelect, NeoSwitch } from '@kodadot1/brick'

@Component({
  components: {
    Layout: () => import('@/components/rmrk/Gallery/Layout.vue'),
    NeoField,
    NeoSwitch,
    NeoCheckbox,
    NeoSelect,
  },
})
export default class Interface extends Vue {
  public paginationOptions = [9, 12, 24, 36]
  public exploreTabOptions = ['GALLERY', 'COLLECTION']
  private preferencesStore = usePreferencesStore()

  get enabledAdvancedUI(): boolean {
    return this.preferencesStore.advancedUI
  }

  set enabledAdvancedUI(value: boolean) {
    this.preferencesStore.setAdvancedUI(value)
  }

  get theatreView(): boolean {
    return this.preferencesStore.theatreView === 'theatre'
  }

  set theatreView(value: boolean) {
    this.preferencesStore.setTheatreView(value)
  }

  get compactGalleryItem(): boolean {
    return this.preferencesStore.compactGalleryItem
  }

  set compactGalleryItem(value: boolean) {
    this.preferencesStore.setCompactGalleryItem(value)
  }

  get compactCollection(): boolean {
    return this.preferencesStore.compactCollection
  }

  set compactCollection(value: boolean) {
    this.preferencesStore.setCompactCollection(value)
  }

  get showPriceValue(): boolean {
    return this.preferencesStore.showPriceGallery
  }

  set showPriceValue(value: boolean) {
    this.preferencesStore.setShowPriceValue(value)
  }

  get showMintTime(): boolean {
    return this.preferencesStore.showMintTimeCollection
  }

  set showMintTime(value: boolean) {
    this.preferencesStore.setShowMintTime(value)
  }

  get replaceBuyNowWithYolo(): boolean {
    return this.preferencesStore.replaceBuyNowWithYolo
  }

  set replaceBuyNowWithYolo(value: boolean) {
    this.preferencesStore.setReplaceBuyNowWithYolo(value)
  }

  get galleryItemsPerPage(): number {
    return this.preferencesStore.galleryItemsPerPage
  }

  set galleryItemsPerPage(value: number) {
    this.preferencesStore.setGalleryItemsPerPage(value)
  }

  get collectionsPerPage(): number {
    return this.preferencesStore.collectionsPerPage
  }

  set collectionsPerPage(value: number) {
    this.preferencesStore.setCollectionsPerPage(value)
  }

  get exploreTabOrder(): string {
    return this.preferencesStore.exploreTabOrder
  }

  set exploreTabOrder(value: string) {
    this.preferencesStore.setExploreTabOrder(value)
  }

  get enableAllArtworks(): boolean {
    return this.preferencesStore.enableAllArtwork
  }

  set enableAllArtworks(value: boolean) {
    this.preferencesStore.setAllArtworkVisible(value)
  }

  get enableGyroEffect(): boolean {
    return this.preferencesStore.enableGyroEffect
  }

  set enableGyroEffect(value: boolean) {
    this.preferencesStore.setEnableGyroEffect(value)
  }
}
